import { render, staticRenderFns } from "./agora-rtm.vue?vue&type=template&id=284c9512"
import script from "./agora-rtm.vue?vue&type=script&lang=js"
export * from "./agora-rtm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports